import { render, staticRenderFns } from "./LinkPrivacy.vue?vue&type=template&id=40334f1d&scoped=true"
import script from "./LinkPrivacy.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkPrivacy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40334f1d",
  null
  
)

export default component.exports